import Vue from 'vue'
import httpconfig from './common/httpconfig.js'
// import Button from 'ant-design-vue/lib/button';
// // import { Button } from 'ant-design-vue';
// import 'ant-design-vue/dist/antd.css';
import Print from 'vue-print-nb'
Vue.use(Print);
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.less'
import './common.less'
import 'lib-flexible'
Vue.use(Antd)


import App from './App.vue'
import router from './router'
import store from './store'

import BaiduMap from 'vue-baidu-map'

import http from './common/httpconfig.js'
import utils from './common/utils.js'
import './common/filter.js'

import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
import Blob from './vendor/Blob'
import Export2Excel from './vendor/Export2Excel.js'
import VueCookies from 'vue-cookies'
//import axios from 'axios'
//import VueAxios from 'vue-axios'

//

import axios from 'axios'
Vue.prototype.$axios= axios
let EventBus = new Vue();
Object.defineProperties(Vue.prototype, {
  $bus: {
    get: function () {
      return EventBus
    }
  }
})
Vue.use(BaiduMap, {
  ak: 't6aZXGzh9YuQbOj5aQtd3M0D2k1fVHc9'
})
Vue.use(VueCookies)
Vue.use(VXETable)
// Vue.component(Button.name, Button);
Vue.config.productionTip = false
Vue.prototype.$http = http
Vue.prototype.utils=utils



new Vue({
router,
  store,
  render: h => h(App)
}).$mount('#app')


router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */





  if (to.matched.some(record => record.meta.requiresAuth)) {
    //这里判断用户是否登录，验证本地存储是否有token

    if (!store.getters.User.enterprise) { // 判断当前的token是否存在
      next({
        path: '/'

      })
    } else {
      to.meta.title='灌溉项目-'+store.getters.User.enterprise.cEntName

      document.title = to.meta.title;
      next()
    }
  } else {
    next() // 确保一定要调用 next()
  }
})
